import { Flex } from "@aircall/tractor";

import { CsatScore } from "@/components/CsatScore/CsatScore";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function BasicCase() {
  return (
    <Flex gap="s" flexWrap="wrap" alignItems="center">
      <CsatScore value={95} />
      <CsatScore value={78} />
      <CsatScore value={52} />
      <CsatScore value={28} />
      <CsatScore value={5} />
      <CsatScore value={null} />
    </Flex>
  );
}

function RatingScaleExamples() {
  const ratings = [
    { label: "High (71-100)", value: 78 },
    { label: "Medium (41-70)", value: 52 },
    { label: "Low (0-40)", value: 28 },
    { label: "Not Applicable (null)", value: null },
  ];

  return (
    <Flex gap="m" flexDirection="column">
      {ratings.map((rating) => (
        <Flex key={rating.label} gap="s" alignItems="center">
          <CsatScore value={rating.value} />
          <span>{rating.label}</span>
        </Flex>
      ))}
    </Flex>
  );
}

function EdgeCases() {
  return (
    <Flex gap="s" flexWrap="wrap" alignItems="center">
      <CsatScore value={-10} />
      <CsatScore value={0} />
      <CsatScore value={78.6} />
      <CsatScore value={100} />
      <CsatScore value={120} />
      <CsatScore value={null} />
    </Flex>
  );
}

export function PlaygroundCsatScore() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <BasicCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Rating Scale Examples
        </PlaygroundSubSectionTitle>
        <RatingScaleExamples />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Edge Cases</PlaygroundSubSectionTitle>
        <EdgeCases />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
